module.exports = __webpack_public_path__ + "img/07.9bbbf748.svg";